import React, { Component } from 'react';
import heic2any from "heic2any";
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from "../../../js/ComponentManager";
import Backdrop from '@mui/material/Backdrop';
//import Dialog from '@mui/material/Dialog';
//import DialogContent from '@mui/material/DialogContent';
/*import DialogContentText from '@mui/material/DialogContentText';*/
//import CircularProgress from '@mui/material/CircularProgress';
//import LinearProgress from '@mui/material/LinearProgress';

/* 개발담당:양유빈
 * 화면기능:상품등록 > 상품사진 등록
 * 세부설명:
*/

export class PhotoUpload extends Component {
    static displayName = PhotoUpload.name;
    static PageComplete = false;
    static filemaxCount = 15;
    static MovingType = {
        Backward: 1,
        Forward: 2,
    }
    constructor(props) {
        super(props);
        this.state = {
            Title: "",
            Content:"",
            File_Grp: null,
            Wmark_Yn: "N",
            totalUpLoadCount: 0,
            currentUploadCount: 0,
            showBackdrop: false,
            dialogopen: false,
            ImageList: [],
            ImageDeleteList: []
        };
        this.hiddenFileInput = React.createRef();
        this.handleFileSearch_Click = this.handleFileSearch_Click.bind(this);
        this.handle_Change = this.handle_Change.bind(this);
        this.handleUpload_Click = this.handleUpload_Click.bind(this);
        this.handleShow_Click = this.handleShow_Click.bind(this);
        this.handleAlert_Clik = this.handleAlert_Clik.bind(this);
        //재전송 로직 초기화
        Big3Common.RetransmissionList = [];
    }
    //초기화
    async componentDidMount() {
        if (this.props.ContentState !== null) {
            let File_Grp = this.props.ContentState.GoodsImgMgtModel.File_Grp;
            let Wmark_Yn = this.props.ContentState.GoodsImgMgtModel.Wmark_Yn;
            if (File_Grp !== "" && File_Grp !== null) {
                await this.CallPhotoData(File_Grp);
            }
            this.setState({ File_Grp: File_Grp, Wmark_Yn: Wmark_Yn });
        }
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    //등록 후 수정 시 이미지 데이터 호출
    async CallPhotoData(File_Grp) {
        try {
            let Data = await Big3Common.Get(`api/Goods/GoodsReg/TempGoodsImage/${File_Grp}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                let imagelist = [];
                DataList.map((list, idx) => {
                    let imagelistmodel = Big3Common.Util.Cloen(this.ImageListModel);
                    imagelistmodel.Crud = "U";
                    imagelistmodel.Guid = list.file_no;
                    imagelistmodel.Name = list.file_nm;
                    imagelistmodel.Seq = idx+1;
                    imagelistmodel.Size = list.file_size;
                    imagelistmodel.Type = `image/${list.extension}`;
                    imagelistmodel.Url = list.img_220;
                    imagelist.push(imagelistmodel);
                    return false;
                });
                this.setState({ ImageList: imagelist });
            }
        }
        catch (e) {
            console.log("CallPhotoData: ", e)
        }
    }
    //파일 탐색기 클릭
    handleFileSearch_Click() {
        //세션 종료확인         
        let fileCount = this.state.ImageList.length;
        if (fileCount >  PhotoUpload.filemaxCount - 1) {
            this.setState({ Title: "업로드안내", Content: `사진은 최대 ${PhotoUpload.filemaxCount}장까지 등록할 수 있습니다.` });
            Big3Common.ModalAlert(bootstrap, 'PhotoUploadAlert');
            return false;
        }
        this.hiddenFileInput.current.click();
    }    
    TempFileList = [];
    TempImageList = [];
    ImageListModel = { "Crud": "", Guid: "", Name: "", Seq: null, Size: null, Type: "", Url: "" };
    //재전송을 위한 템프리스트
    TempRetransFileList = [];
    handle_Change(event) {
        //재전송 파일객체 담기
        Array.from(event.target.files).map(list => this.TempRetransFileList.push(list));

        this.TempFileList = event.target.files;
        let ImageCount = (this.TempFileList.length + this.state.ImageList.length);
        if (ImageCount <= PhotoUpload.filemaxCount) {
            this.setState({
                "showBackdrop": true
            });
            this.TempImageList = this.state.ImageList;
            this.FileHandler(0);
        }
        else {
            this.setState({ Title: "업로드안내", Content: `사진은 최대 ${PhotoUpload.filemaxCount}장까지 등록할 수 있습니다.` });
            Big3Common.ModalAlert(bootstrap, 'PhotoUploadAlert');
            this.TempFileList = [];       
            this.TempRetransFileList = [];
        }
        
        event.preventDefault();
    }
    FileHandler = (idx) => {
        return new Promise((resolve, reject) => {
            let _this = this;
            let FileList = _this.TempFileList
            let ImageList = _this.TempImageList;

            //#################재귀호출 종료
            if (FileList.length <= idx) {
                //처리
                this.setState({
                    "showBackdrop": false,
                    "ImageList": _this.TempImageList
                });
                
            }
            else {

                let SelectFile = FileList[idx];
                let Seq = ImageList.length > 0 ? ImageList[ImageList.length - 1].Seq : 0;
                let reader = new FileReader();
                if (SelectFile.name.toLowerCase().includes(".heic")) {
                    //heic 파일(아이폰) 이미지 포멧 처리
                    heic2any({ blob: SelectFile, toType: "image/jpeg" }).then(function (resultBlob) {
                        SelectFile = new File([resultBlob], SelectFile.name.split('.')[0] + ".jpg", { type: "image/jpeg", lastModified: new Date().getTime() });
                        reader.addEventListener('load', function (event) {
                            if (event.type === "load") {
                                try {
                                    //인코딩 검사
                                    //const base64 = this.result.split(',')[1];
                                    //const Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/;
                                    let ImageProps = {
                                        Seq: (Seq) + 1,
                                        Url: this.result,
                                        Size: SelectFile.size,
                                        Name: SelectFile.name,
                                        Type: SelectFile.type,
                                        Crud: "C",
                                        Guid: Big3Common.getGuid()
                                    };
                                    _this.TempImageList.push(ImageProps);
                                }
                                catch (e) {
                                    reject(false);
                                }
                            }
                            resolve(true);
                        }, false);
                        reader.onerror = () => {
                            reject(false);
                        };
                       reader.addEventListener('loadend', function (event) {
                            if (event.type === "loadend") {
                                //파일 변환 처리 후 종료 이벤트. 재귀적 호출 시작
                                _this.FileHandler((idx + 1));
                            }
                        });
                        reader.readAsDataURL(SelectFile);
                    });
                }
                else {
                    //표준 이미지 포멧 처리
                    if (SelectFile instanceof Blob) {
                        const realFileReader = reader._realReader;
                        if (realFileReader) {
                            reader = realFileReader;
                        }
                    }
                    reader.addEventListener('load', function (event) {
                        if (event.type === "load") {
                            try {
                                //인코딩 검사
                                //const base64 = this.result.split(',')[1];
                                //const Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/;
                                let ImageProps = {
                                    Seq: (Seq) + 1,
                                    Url: this.result,
                                    Size: SelectFile.size,
                                    Name: SelectFile.name,
                                    Type: SelectFile.type,
                                    Crud: "C",
                                    Guid: Big3Common.getGuid()
                                };
                               _this.TempImageList.push(ImageProps);
                            }
                            catch (e) {
                                reject(false);
                            }
                        }
                        resolve(true);
                    }, false);

                    reader.onerror = () => {
                        reject(false);
                    };
                    reader.addEventListener('loadend', function (event) {
                        if (event.type === "loadend") {
                            //파일 변환 처리 후 종료 이벤트. 재귀적 호출 시작
                           _this.FileHandler((idx + 1));
                        }
                    });
                    reader.readAsDataURL(SelectFile);
                }
            }
        });
    }
    //이미지 삭제 처리
    DeleteImageBox(ImageData) {

        let ImageList = this.state.ImageList;
        let ImageDeleteList = this.state.ImageDeleteList;

        //삭제대상 탐색
        let idx = ImageList.length;
        while (idx--) {
            let List = ImageList[idx];
            if (List.Seq === ImageData.Seq) {
                let DeleteRow = JSON.stringify(List);
                if (List.Crud !== "C") {
                    //처음 등록하려는 파일은 그냥 삭제. 기 등록된 데이터만 추가
                    ImageDeleteList.push(JSON.parse(DeleteRow));
                }

                ImageList.splice(idx, 1);
            }
        }
        
        //삭제 후 시퀀스 재 정리
        ImageList.map((List, idx) => {
            List.Seq = idx + 1;
            return false;
        });
         
        this.forceUpdate();
    }
    //현재선택된 이미지박스 번호
    SelectImgBoxSeq = null;
    MoveImageBox(ImageData, Moving) {

        let ImageList = this.state.ImageList;
        if (ImageList == null || ImageList.length === 1) return;

        if (PhotoUpload.MovingType.Backward === Moving) {
            //첫번째 이미지
            let firstSeq = ImageList[0].Seq;
            if (firstSeq === ImageData.Seq) {
                return false;
            }
        }
        else if (PhotoUpload.MovingType.Forward === Moving) {
            //마지막 이미지
            let lastSeq = ImageList[ImageList.length - 1].Seq;
            if (lastSeq === ImageData.Seq) {
                return false;
            }
        }

        let thisStep = ImageData.Seq;                                         //대상 이미지 번호
        let MovingStep = 0;
        if (PhotoUpload.MovingType.Backward === Moving) {
            let BackwardList = ImageList.filter(list => list.Seq < thisStep); //대상 번호보다 바로 하나 작은 번호
            MovingStep = BackwardList[BackwardList.length - 1].Seq;
        }
        else if (PhotoUpload.MovingType.Forward === Moving) {
            MovingStep = ImageList.filter(list => list.Seq > thisStep)[0].Seq;  // 대상 번호보다 바로 하나 큰 번호
        }
        
        let List1 = null;
        let List2 = null;
        let idx = ImageList.length;
        while (idx--) {
            let List = ImageList[idx];
            if (List.Seq === thisStep) {
                List1 = JSON.parse(JSON.stringify(List));
                List1.Seq = MovingStep;
                ImageList.splice(idx, 1);
            }
            if (List.Seq === MovingStep) {
                List2 = JSON.parse(JSON.stringify(List));
                List2.Seq = thisStep;
                ImageList.splice(idx, 1);
            }
        }
        if (List1 != null && List2 != null) {
            ImageList.push(List1);
            ImageList.push(List2);
        }
        this.ImageListSort(ImageList);
        ImageList.map((List, idx) => {
            List.Seq = idx + 1;
            return false;
        });
        this.SelectImgBoxSeq = MovingStep;
        this.forceUpdate();
        return false;
    }
    handleShow_Click(event, ImageData) {
        
        let className = event.target.classList[0];
       
        if (className === "photo_upload") {
            this.SelectImgBoxSeq = ImageData.Seq;
            this.forceUpdate();
        }
        else if (className === "photo_delete") {
            this.DeleteImageBox(ImageData);
        }
        else if (className === "arrow_before") {
            this.MoveImageBox(ImageData, PhotoUpload.MovingType.Backward);
        }
        else if (className === "arrow_next") {
            this.MoveImageBox(ImageData, PhotoUpload.MovingType.Forward);
        }
        return false;
    }
    //################ 서버로 파일 업로드 처리 시작
    async handleUpload_Click() {

        //세션확인
        let isSession = Big3Common.Authentication(this);
        if (!isSession) {
            return false;
        }

        //업로드 파일 사이즈
        let isValid = true;
        let ImageUpLoadSize = Big3Common.WebConfig.ImageUpLoadSize;
        let UpLoadList = this.state.ImageList;
        //파일 사이즈 검증
        let overFileSize = UpLoadList.filter(list => list.Size > ImageUpLoadSize);
        if (overFileSize.length > 0) {
            isValid = false;
            let overSizeName = overFileSize[0].Name;
            let overSeq = overFileSize[0].Seq;
            let overSize = overFileSize[0].Size;
            let Content = `${overSeq}번째 첨부파일  ${overSizeName}는 업로드 용량(${Big3Common.Util.ByteToMb(overSize)}Mb)을 초과 했습니다.\n파일당 최대 사이즈는 ${Big3Common.Util.ByteToMb(ImageUpLoadSize) }Mb입니다.`;
            this.setState({ Title: "업로드안내", Content: Content });
            Big3Common.ModalAlert(bootstrap, 'PhotoUploadAlert');
        }
        //업로드 파일이 있는지 검증
        let UpLoadCount = UpLoadList.filter(list => list.Crud === "C" || list.Crud === "U").length;
        let DeletCount = this.state.ImageDeleteList.length;
        if ((UpLoadCount + DeletCount) === 0) {
            isValid = false;
            this.setState({ Title: "업로드안내", Content: "변경된 내역이 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'PhotoUploadAlert');            
        }
        if (UpLoadCount === 0) {
            isValid = false;
            this.setState({ Title: "업로드안내", Content: "상품 사진은 최소 1장은 등록되어야 합니다." });
            Big3Common.ModalAlert(bootstrap, 'PhotoUploadAlert');            
        }
        //파일확장자 체크
        const NoformatCount = UpLoadList.filter(file => {
            const extension = file.Type.toLowerCase();
            return !['image/jpeg', 'image/jpg', 'image/png'].includes(extension);
        }).length;

        if (NoformatCount >0) {
            isValid = false;
            this.setState({ Title: "업로드안내", Content: "상품 이미지는 jpg,jpeg,gif만 가능합니다." });
            Big3Common.ModalAlert(bootstrap, 'PhotoUploadAlert');
        }

        if (!isValid) {
            return false;
        }

        //총 파일 업로그 개수를 변수에 할당.
        this.setState({ totalUpLoadCount: UpLoadCount });
        let totalUpLoadCount = UpLoadCount;
        
        //파일 업로드 시작
        this.setState({ dialogopen: true });
        let currentUploadCount = 0;
        let FileUpLoadList = [];

        for (const list of UpLoadList) {
            if (list.Crud === "C") {
                let result = await Big3Common.FileUpLoadModule("api/Goods/PhotoUpload/ImageSave", {
                    FileSeq: list.Seq,
                    BlobData: list.Url,
                    FileSize: list.Size,
                    FileName: list.Name,
                    FileType: list.Type,
                    CrudType: list.Crud,
                    Guid: list.Guid,
                    Storage: Big3Common.WebConfig.FileStoragePath.GoodsImageInfo,
                    Wmark_Yn: this.state.Wmark_Yn,
                    ExtensionAdd: "Y"
                });
                if (result) {
                    //업로드된 개수와 정보를 배열에 등록                    
                    currentUploadCount++;
                    this.setState({ currentUploadCount: currentUploadCount });
                    let FileMst = {
                        crud: list.Crud,
                        file_no: list.Guid,
                        file_nm: list.Name,
                        file_size: list.Size,
                        uplcomp_yn: this.state.File_Grp === null ? "N" : "Y",
                        ord_by: list.Seq
                    }
                    //업로할 목록
                    FileUpLoadList.push(FileMst);
                }
            }
            else {
                //기 등록된 이미지는 동일 값만 업데이트 순번만 변경됨.
                currentUploadCount++;
                this.setState({ currentUploadCount: currentUploadCount });
                let FileMst = {
                    crud: list.Crud,
                    file_no: list.Guid,
                    file_nm: list.Name,
                    file_size: list.Size,
                    uplcomp_yn: "Y",
                    ord_by: list.Seq
                }
                //업로할 목록
                FileUpLoadList.push(FileMst);
            }
            //-------------> 파일 업로드 처리가 끝난 후 
            if (currentUploadCount === totalUpLoadCount) {
                let Data = await Big3Common.Post("api/Goods/PhotoUpload/PhotoUploadFile",
                    {
                        file_grp: this.state.File_Grp,
                        fileuploadlist: FileUpLoadList,
                        filedeletelist: this.state.ImageDeleteList
                    });
                let Content = "";
                let file_grp = "";

                //파일 손실이 발생 재전송 1회 처리
                if (Data.codeName === Big3Common.ResultCode.Success && Big3Common.RetransmissionList.length > 0) {
                    file_grp = Data.objectData;
                    let RetransFileUpLoadList = [];
                    try {
                        //재전송 처리
                        const RetransmissionList = UpLoadList.filter(item => Big3Common.RetransmissionList.some(retransmissionItem => retransmissionItem.Guid === item.Guid));
                        let reTransCount = 0;
                        for (const retList of RetransmissionList) {
                            //Base64 재 인코딩
                            let REURL = "";
                            try {
                                REURL = await this.RetransmissionReader(retList);
                                //파일 재 업로드
                                //재 전송하는 내역은 GUID를 변경하여 추가 등록
                                let GUID = Big3Common.getGuid();
                                const CRUD = "C";
                                console.log("재전송시작==>", GUID)
                                let saveResult = await Big3Common.FileUpLoadModule("api/Goods/PhotoUpload/ImageSave", {
                                    FileSeq: retList.Seq,
                                    BlobData: REURL,
                                    FileSize: retList.Size,
                                    FileName: retList.Name,
                                    FileType: retList.Type,
                                    CrudType: CRUD,
                                    Guid: GUID,
                                    Storage: Big3Common.WebConfig.FileStoragePath.GoodsImageInfo,
                                    Wmark_Yn: this.state.Wmark_Yn,
                                    ExtensionAdd: "Y"
                                });
                                if (saveResult) {
                                    let FileMst = {
                                        crud: CRUD,
                                        file_no: GUID,
                                        file_nm: retList.Name,
                                        file_size: retList.Size,
                                        uplcomp_yn: this.state.File_Grp === null ? "N" : "Y",
                                        ord_by: retList.Seq
                                    }
                                    //캐시 삭제 항목 추가
                                    FileUpLoadList.push(FileMst);
                                    //재전송 리스트 추가
                                    RetransFileUpLoadList.push(FileMst);
                                }
                                console.log("saveResult==>", saveResult);
                                //카운트 증가
                                reTransCount++;

                                //재전송된 내역 DB 등록
                                if (RetransmissionList.length === reTransCount) {
                                    let Data = await Big3Common.Post("api/Goods/PhotoUpload/PhotoUploadFile",
                                        {
                                            file_grp: file_grp,
                                            fileuploadlist: RetransFileUpLoadList,
                                            filedeletelist: []
                                        });
                                    if (Data.codeName === Big3Common.ResultCode.Success) {
                                        console.log("===>재전송 완료")
                                        Content = '이미지 업로드가 완료 되었습니다.';
                                        PhotoUpload.PageComplete = true;
                                        //objectData는 처음 등록된 file_grp 그룹과 같은 코드임.
                                        file_grp = Data.objectData;
                                    }
                                    else {
                                        PhotoUpload.PageComplete = true;
                                        Content = Data.message;
                                    }
                                    this.finallyProcess(FileUpLoadList, Content, file_grp);
                                }
                            }
                            catch (e) {
                                console.log("재전송 Read 실패:==>", e);
                                PhotoUpload.PageComplete = true;
                                this.finallyProcess(FileUpLoadList, "파일전송에 장애가 발생했습니다.\n재업로드 부탁드립니다.", file_grp);
                            }
                        }

                    }
                    catch (e) {
                        console.log("재전송 실패:==>", e);

                    }
                    finally {
                        Big3Common.RetransmissionList = [];

                    }
                }
                else {
                    if (Data.codeName === Big3Common.ResultCode.Success) {
                        Content = '이미지 업로드가 완료 되었습니다.';
                        file_grp = Data.objectData;
                        PhotoUpload.PageComplete = true;
                    }
                    else {
                        PhotoUpload.PageComplete = true;
                        Content = Data.message;
                    }
                    this.finallyProcess(FileUpLoadList, Content, file_grp);
                }
            }            
        }
        return false;

    }
    finallyProcess = async (FileUpLoadList, Content, file_grp) => {
        
        this.setState({
            dialogopen: false,
            Title: "업로드안내",
            Content: Content,
            File_Grp: file_grp
        });
        await Big3Common.Post("api/Goods/PhotoUpload/RemovePhotoUploadCache",
        {
            fileuploadlist: FileUpLoadList
        });
        Big3Common.ModalAlert(bootstrap, 'PhotoUploadAlert');
         
    }
    //재전송 매커니즘 전환시 Base64값을 다시 반환 시킴.
    RetransmissionReader = async (retList) => {
        return new Promise((resolve, reject) => {
            
            let SelectFile = [];
            this.TempRetransFileList.map((list) => {
                const TempRetransFile = list;
                const matchesName = TempRetransFile.name.toLowerCase();
                const expendName = matchesName.substring(matchesName.lastIndexOf(".") + 1).toLowerCase();
                if (expendName === "heic") {
                    const targetName = retList.Name.toLowerCase();
                    //확장자 제외 명칭(bas64로 변환하면서 jpeg로 변경됨)
                    const matchesName2 = matchesName.substring(0, matchesName.indexOf("."));
                    const targetName2 = targetName.substring(0, targetName.indexOf("."));
                    if (encodeURIComponent(matchesName2.toString().toLowerCase()) === encodeURIComponent(targetName2.toString().toLowerCase())) {
                        SelectFile = TempRetransFile;
                    }
                }
                else {
                    //일반파일 처리
                    if (encodeURIComponent(matchesName.toString().toLowerCase()) === encodeURIComponent(retList.Name.toString().toLowerCase())) {
                        SelectFile = TempRetransFile;
                    }
                }
                return false;
            });
             
            if (SelectFile.length === 0) {
                reject("SelectFile 없음");
            }
            
            let reader = new FileReader();
            if (SelectFile.name.toLowerCase().includes(".heic")) {
                //heic 파일(아이폰) 이미지 포멧 처리
                heic2any({ blob: SelectFile, toType: "image/jpeg" }).then(function (resultBlob) {
                    SelectFile = new File([resultBlob], SelectFile.name.split('.')[0] + ".jpg", { type: "image/jpeg", lastModified: new Date().getTime() });
                    reader.addEventListener('load', function (event) {
                        if (event.type === "load") {
                            resolve(this.result);
                        }
                    });
                    reader.addEventListener('error', function (event) {
                        reject("heic reader error");
                    });
                    reader.readAsDataURL(SelectFile);
                });
            }
            else {
                reader.addEventListener('load', function (event) {
                    if (event.type === "load") {
                        resolve(this.result);
                    }
                });
                reader.addEventListener('error', function (event) {
                    reject("jpg reader error");
                });
                reader.readAsDataURL(SelectFile);
            }
        });
    }
    handleAlert_Clik() {
        if (PhotoUpload.PageComplete) {
            let ContentState = this.props.ContentState;
            ContentState.GoodsImgMgtModel.File_Grp = this.state.File_Grp;
            ContentState.GoodsImgMgtModel.Wmark_Yn = this.state.Wmark_Yn;
            this.props.RenderComponent('GoodsReg', ContentState);
        }
        
        return false;
    }
    ImageListSort(ImageList) {
        ImageList.sort((a, b) => {
            if (a.Seq < b.Seq) return -1;
            if (a.Seq > b.Seq) return 1;
            return 0;
        });
    }
    photoZone(ImageList) {        
        let ImageListBinder = ImageList;
        this.ImageListSort(ImageListBinder);
        let ImgBoxSeq = this.SelectImgBoxSeq;
        let VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
                
        return (
            ImageListBinder.map((ImageData, idx) =>
                <div className="photo_upload photo_selected"
                    key={idx}
                    style={{ backgroundImage: ImageData.Crud === "C" ? `url(${ImageData.Url})` : `url(${VirtualRoot}${ImageData.Url})` }}
                    onClick={(e) => this.handleShow_Click(e, ImageData) }
                >
                    <div className={idx === 0 ? "main_photo" : "item_hide"}>메인이미지</div>
                    <div className={ImgBoxSeq === ImageData.Seq ? "photo_delete pointer" : " item_hide"}></div>
                    <div className={ImgBoxSeq === ImageData.Seq ? "arrow_before pointer" : " item_hide"}></div>
                    <div className={ImgBoxSeq === ImageData.Seq ? "arrow_next pointer" : " item_hide"} ></div>
               </div>
                
            )
        );
    }
    Progress() {
        
        return (
            <div>
                <div className="loader_box loader_box2">
                    <div className="clogo clogo2"></div>
                </div>
                <div className="loader_txt2">
                    <p>UPLOAD</p>
                    <p>({this.state.currentUploadCount}/{this.state.totalUpLoadCount})</p>
                </div>
            </div>
        )
    }
    render() {
        let photoZones = this.photoZone(this.state.ImageList);
        let isWaterMk = true;//워터마크 적용여부
        if (this.state.ImageList === 0) {
            //사진이 없을때
            isWaterMk = false;
        }
        else if (this.state.ImageList.filter(list => list.Crud === "U").length === 0) {
            //기존 등록된 사진이 없을때
            isWaterMk = false;
        }
        
        return (
            <div>
                <div className="photo_wrap">
                    <div className="photo_up_box_out row row-cols-3">
                        <div className="photo_upload col upload_btn">
                            <div className="photo_upload_in" onClick={this.handleFileSearch_Click}>
                                <div className="plus">
                                    <form method="post">
                                        <input type="file" style={{ display: 'none' }} 
                                            name='images'
                                            multiple
                                            ref={this.hiddenFileInput}
                                            onChange={this.handle_Change}
                                            accept="image/gif,image/jpeg,image/png,image/heic"
                                        />
                                    </form>
                                </div>
                                <div className="photo_number">({this.state.ImageList.length} /15)</div>
                                
                            </div>
                        </div>
                        {photoZones}
                    </div>
                </div>
                <div className="photo_info">
                    <div className="info_txt">
                        <ul>
                            <li><b>해외 판매 동의 상품은 마지막 이미지에 사이즈 실측 이미지를 등록하시면, 구매자의 신뢰도를 높이고 판매율을 높일 수 있습니다.</b></li>
                        </ul>
                        <ul>
                            <li>네트워크 환경에 따라 업로드 속도에 차이가 있을 수 있습니다.</li>
                            <li>빠른 속도를 위해서는 <b>와이파이 사용</b>을 권장합니다</li>
                            <li>사진은 최대 15장까지 등록할 수 있습니다.</li>
                            <li>사진 1장당 5Mb 이하, 전체 75Mb 이하까지 가능합니다.</li>
                            <li>상표권, 저작권 침해 상품은 등록이 불가합니다.</li>
                        </ul>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox"
                            value={this.state.Wmark_Yn}
                            id="Wmark_Yn"
                            defaultChecked={this.props.ContentState.GoodsImgMgtModel.Wmark_Yn === "Y" ? true : false}
                            disabled={isWaterMk}
                            onClick={(e) => this.setState({ Wmark_Yn: e.target.checked === true ? "Y":"N" })}
                        />
                        <label className="form-check-label">
                            선택시 워터마크가 자동으로 추가됩니다.
                        </label>
                    </div>
                    <button type="button"
                        className="btn_v btn_v1"
                        onClick={this.handleUpload_Click}
                    >확인</button>
                </div>
                <div style={{ display: this.state.showBackdrop===true ? "block" : "none" }}>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={this.state.showBackdrop}
                    >
                        <div className="loader_box">
                            <div className="spinner"></div>
                            <p>사진 변환중</p>
                        </div>
                    </Backdrop>
                </div>
                <div style={{ display: this.state.dialogopen === true ? "block" : "none" }}>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={this.state.dialogopen}
                    >
                     {this.Progress()}
                    </Backdrop>
                </div>
                <Alert
                    id="PhotoUploadAlert"
                    title={this.state.Title}
                    content={this.state.Content}
                    backdrop={false}
                    AlertClick={(e) =>this.handleAlert_Clik(e)}
                />
            </div>
        );
    }
}
